/**
 * Symbolická datumová konstanta.
 */
export const SymbolicDate = {
    TODAY: 'TODAY',
    TODAY_PLUS_WEEK: 'TODAY_PLUS_WEEK',
    TODAY_PLUS_TWO_WEEKS: 'TODAY_PLUS_TWO_WEEKS',
    TODAY_PLUS_MONTH: 'TODAY_PLUS_MONTH',
    TODAY_AND_FUTURE: 'TODAY_AND_FUTURE',
    TODAY_PLUS_MINUS_WEEK: 'TODAY_PLUS_MINUS_WEEK',
    THIS_WEEK: 'THIS_WEEK',
    THIS_MONTH: 'THIS_MONTH',
    THIS_YEAR: 'THIS_YEAR',
    NEXT_WEEK: 'NEXT_WEEK',
    NEXT_MONTH: 'NEXT_MONTH',
    NEXT_YEAR: 'NEXT_YEAR'
};

/**
 * Položka na výběr v datumovém filtru.
 */
export const DateFilterItem = {
    ...SymbolicDate,
    CUSTOM: 'CUSTOM',
};
